import { axios } from 'Fetcher'
import { firebaseServicePromise } from 'store'
import { PromoCodeValidationResult } from 'types/uscTypes'

/** This flow only ever redeems Urban Sports Club vouchers. */
const USC_PARTNER = 'usc'

export const PromoCodeService = {
  /**
   * Read-only pre-check, no auth required — lets the landing page reject a bad
   * code before asking the member to create an account. Cannot detect the per-user
   * refusals `already_redeemed` and `already_has_active_voucher`; see
   * specs/002-promo-code-backend/contracts/validatePromoCode.md
   */
  validateCode: async (code: string): Promise<PromoCodeValidationResult> => {
    const res = await axios({
      method: 'POST',
      url: '/api/promo/validate',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        code,
        partner: USC_PARTNER
      }
    })

    return res.data.data
  },
  /**
   * Redeems for the signed-in user; the server grants the free access window.
   * Scoped to USC, so a code belonging to anyone else comes back `wrong_partner`.
   */
  redeemCode: async (code: string): Promise<PromoCodeValidationResult> => {
    const firebaseService = await firebaseServicePromise
    const idToken = await firebaseService.getIdToken()

    const res = await axios({
      method: 'POST',
      url: '/api/promo/redeem',
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json'
      },
      data: {
        code,
        partner: USC_PARTNER
      }
    })

    return res.data.data
  }
}
